export type PortfolioSort = "name" | "city" | "models";
type Property = { id: string; name: string | null; address: string | null; city: string | null; state: string | null; modelCount: number };
export function publicPortfolioResults<T extends Property>(properties: readonly T[], query: string, sort: PortfolioSort): T[] {
  const terms = query.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
  return properties.filter(property => {
    const text = [property.name, property.address, property.city, property.state].filter(Boolean).join(" ").toLocaleLowerCase();
    return terms.every(term => text.includes(term));
  }).sort((a, b) => {
    const primary = sort === "models" ? b.modelCount - a.modelCount : sort === "city" ? (a.city ?? "").localeCompare(b.city ?? "") : 0;
    return primary || (a.name ?? a.address ?? "").localeCompare(b.name ?? b.address ?? "", undefined, { numeric: true }) || a.id.localeCompare(b.id);
  });
}
